import { createAction } from 'redux-actions';

export const toggleSidebarNav = createAction('TOGGLE_GUEST_SIDEBAR_NAV');
